// Centralized API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || `https://${window.location.hostname}:5005`;

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  SIGNUP: '/signUp',
  SIGNIN: '/signIn',
  
  // Mentors
  ALL_MENTORS: '/allmentors',
  
  // Add more endpoints as needed
};

// Create axios instance with base URL
export const createApiInstance = () => {
  const axios = require('axios');
  
  const instance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add request interceptor to include auth token
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor for error handling
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Handle unauthorized access
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default API_BASE_URL;
